module.exports = __webpack_public_path__ + "website/img/sq.7475c950.jpg";